import React from "react";
import { DxTabbedContent, DxTabPanel } from "genesys-react-components";
import "../App.css";
import WebRTCFix from "./WebRTCFix";
import ScreenRecordings from "./ScreenRecordings";
// import LogCapture from "./LogCapture";

const Tabs = ({ authenticate, pageCount,
  setPageCount,
  pageNumber,
  setPageNumber }) => {

  return (
    <>
      <DxTabbedContent>
        {/* <DxTabPanel title={<button className="tab-button">Log Capture</button>}>
          <LogCapture />
        </DxTabPanel> */}
        <DxTabPanel title={<button className="tab-button">WebRTC Tool</button>}>
          <WebRTCFix
            authenticate={authenticate}
          />
        </DxTabPanel>
        <DxTabPanel title={<button className="tab-button">Failed Screen Recordings</button>}>
          <ScreenRecordings
            pageCount={pageCount}
            setPageCount={setPageCount}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
          />
        </DxTabPanel>
      </DxTabbedContent>
    </>
  );
};

export default Tabs;
